// @ts-nocheck

import React, { useMemo, createContext } from 'react';

import type { AnyObject } from '../../types/utils';

type WinabetLibProviderContext = {
  parentRef?: unknown;
  sharedData?: AnyObject;
  sharedActions?: AnyObject;
  sharedActions?: AnyObject;
};

export const WinabetLibContext = createContext<WinabetLibProviderContext>({
  parentRef: null,
  sharedData: null,
  sharedActions: null,
});

type WinabetLibProviderProps = WinabetLibProviderContext & {
  children?: React.ReactNode;
};

const WinabetLibProvider = ({ parentRef, sharedData, sharedActions, children }: WinabetLibProviderProps) => {
  const value = useMemo(() => ({ parentRef, sharedData, sharedActions }), [parentRef, sharedData, sharedActions]);
  return <WinabetLibContext.Provider value={value}>{children}</WinabetLibContext.Provider>;
};

export default WinabetLibProvider;
